import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import questionIcon from '../../../assets/images/icon/question-small.svg';

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
  height: 15px;
`;


const Text = styled.p`
	display: inline-block;
	margin: 0;
	&>* {
		font-family: Montserrat;
 	 	font-size: 12px;
 	 	color: ${props => props.theme.colors.lightgrey};
  	text-decoration: underline;
  	&:hover {
  		cursor: pointer;
  	}
  	&:hover, &:focus, &:active, &:visited {
  		color: ${props => props.theme.colors.lightgrey};
  	}
	}
`;

const Icon = styled.span`
	background: url(${questionIcon}) no-repeat 50%;
  height: 15px;
  width: 15px;
  margin-right: 15px;
`;

const DescriptionWrapper = styled.div`
	display: none;
  position: absolute;
  bottom: 35px;
  left: -20px;
  right: -20px;
  box-sizing: border-box;
  background-color: ${props => props.theme.colors.cremewhite};
  ${Wrapper}:hover & {
  	display: block;
  }
`;

const Description = styled.p`
	padding: 15px;
  background-color: ${props => props.theme.colors.beige20};
  border: 1px solid ${props => props.theme.colors.darkgrey60};
  font-family: Montserrat;
  color: ${props => props.theme.colors.darkgrey};
  font-size:12px;
  line-height: 1.3;
  position: relative;
`;

const Arrow = styled.div`
	width: 0;
  height: 0;
  border-top: 11px solid #ded6c9;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: relative;
  bottom: 13px;
  left: -10px;
`;

const ArrowBorder = styled.div`
	position: absolute;
  left: 16px;
  bottom: -2px;
  width: 0;
  height: 0;
  border-top: 12px solid ${props => props.theme.colors.darkgrey60};
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
`;

const Question = ({text, description = ''}) => {
	return (
		<Wrapper>
			<Icon />
			<Text>
				{ text }
			</Text>
			{ description && (
				<DescriptionWrapper>
					<Description>
						{ description }
					</Description>
					<ArrowBorder>
						<Arrow />
					</ArrowBorder>

				</DescriptionWrapper>
			) }
		</Wrapper>
	)
};

Question.propTypes = {
	text: PropTypes.node.isRequired,
	description: PropTypes.string
};

export default Question;
